import { format, isValid, parse, parseISO } from 'date-fns';

import {
  SET_ANIMAL_FILTER,
  SET_DATE_FILTER,
  SET_EVENT_FILTER,
  SET_FILTER_OPTIONS,
  SET_TIME_FILTER,
  SET_ZOO_FILTER,
  TOGGLE_ANIMAL_FILTER,
  TOGGLE_DATE_FILTER,
  TOGGLE_EVENT_FILTER,
  TOGGLE_TIME_FILTER,
  TOGGLE_ZOO_FILTER,
} from '../types';

const initialState = {
  availableZoos: [],
  availableAnimals: [],
  availableEvents: [],
  availableDates: [],
  filters: {
    showEventFilter: false,
    events: [],
    showAnimalFilter: false,
    animals: [],
    showZooFilter: false,
    zoos: [],
    showDateFilter: false,
    dates: [undefined, undefined],
    time: {
      startTime: null,
      endTime: null,
    },
    showTimeFilter: false,
  },
  sessions: [],
};

const validatedDates = (dates, availableDates) => {
  if (!availableDates || !availableDates.length) {
    return initialState.filters.dates;
  }
  const dateFormat = 'yyyy-MM-dd';
  const now = new Date();
  const minDate = parseISO(availableDates[0]);
  const maxDate = parseISO(availableDates[availableDates.length - 1]);
  let date = dates[0] ? parse(dates[0], dateFormat, now) : minDate;
  if (!isValid(date)) {
    date = minDate;
  }
  let endDate = dates[1] ? parse(dates[1], dateFormat, now) : maxDate;
  if (!isValid(endDate)) {
    endDate = maxDate;
  }
  if (endDate < date) {
    [date, endDate] = [endDate, date];
  }
  if (date < minDate) {
    date = minDate;
  }
  if (date > maxDate) {
    date = maxDate;
  }
  if (endDate > maxDate) {
    endDate = maxDate;
  }
  return [format(date, dateFormat), format(endDate, dateFormat)];
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_FILTER_OPTIONS: {
      const { animals, events, zoos, dates } = payload;
      return {
        ...state,
        availableAnimals: animals,
        availableEvents: events,
        availableZoos: zoos,
        availableDates: dates,
      };
    }
    case TOGGLE_EVENT_FILTER: {
      return {
        ...state,
        filters: {
          ...state.filters,
          showEventFilter: !state.filters.showEventFilter,
        },
      };
    }
    case TOGGLE_ANIMAL_FILTER: {
      return {
        ...state,
        filters: {
          ...state.filters,
          showAnimalFilter: !state.filters.showAnimalFilter,
        },
      };
    }
    case TOGGLE_ZOO_FILTER: {
      return {
        ...state,
        filters: {
          ...state.filters,
          showZooFilter: !state.filters.showZooFilter,
        },
      };
    }
    case TOGGLE_DATE_FILTER: {
      return {
        ...state,
        filters: {
          ...state.filters,
          showDateFilter: !state.filters.showDateFilter,
        },
      };
    }
    case TOGGLE_TIME_FILTER: {
      return {
        ...state,
        filters: {
          ...state.filters,
          showTimeFilter: !state.filters.showTimeFilter,
        },
      };
    }
    case SET_TIME_FILTER: {
      const { startTime, endTime } = payload;
      return {
        ...state,
        filters: {
          ...state.filters,
          time: {
            startTime,
            endTime,
          },
          showTimeFilter: false,
        },
      };
    }
    case SET_ZOO_FILTER: {
      const { zoos } = payload;
      return {
        ...state,
        filters: {
          ...state.filters,
          zoos,
          showZooFilter: false,
        },
      };
    }
    case SET_EVENT_FILTER: {
      const { events } = payload;
      return {
        ...state,
        filters: {
          ...state.filters,
          events,
          showEventFilter: false,
        },
      };
    }
    case SET_ANIMAL_FILTER: {
      const { animals } = payload;
      return {
        ...state,
        filters: {
          ...state.filters,
          animals,
          showAnimalFilter: false,
        },
      };
    }
    case SET_DATE_FILTER: {
      const { dates } = payload;
      return {
        ...state,
        filters: {
          ...state.filters,
          dates: validatedDates(dates, state.availableDates),
        },
      };
    }
    default: {
      return state;
    }
  }
};
